import { Protected } from "@stardeck-customer-apps/project-auth";
import { BrowserRouter as Router, Outlet, Route, Routes } from "react-router-dom";

import About from "@/pages/about";
import Accommodation from "@/pages/accommodation";
import Activities from "@/pages/activities";
import AdminDashboard from "@/pages/admin/admin-dashboard";
import AdminLogin from "@/pages/admin/admin-login";
import Booking from "@/pages/booking";
import Contact from "@/pages/contact";
import UserDashboard from "@/pages/dashboard/user-dashboard";
import Dining from "@/pages/dining";
import FAQ from "@/pages/faq";
import Gallery from "@/pages/gallery";
import { Home } from "@/pages/home";
import SiteLayout from "@/pages/layout";
import LocationMap from "@/pages/location";
import Login from "@/pages/login";
import { NotFound } from "@/pages/not-found";
import Policies from "@/pages/policies";
import Rates from "@/pages/rates";
import { Unauthorized } from "@/pages/unauthorized";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <Routes>
          {/* Marketing site */}
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/rates" element={<Rates />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/dining" element={<Dining />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/location" element={<LocationMap />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/booking" element={<Booking />} />
          </Route>

          {/* Auth routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <Protected requiredPermission="deployment:admin-panel:write">
                <Outlet />
              </Protected>
            }
          >
            <Route path="" element={<AdminDashboard />} />
          </Route>
          <Route
            path="/dashboard"
            element={
              <Protected requiredPermission="deployment:user:write">
                <Outlet />
              </Protected>
            }
          >
            <Route path="" element={<UserDashboard />} />
          </Route>

          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
